import { CDN_CLRSAVE_URL } from '../../../constants/index';
import styles from './topPlansSection.scss';

// import { Heading } from '../../common/heading';
import { Link } from '../../../configs/routes';

export const TopPlansSection = ({ SECTION_TOP_PLANS }) => (
  <div id="top-plans" className="lil-container lil-mt-16">
    <div>
      <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32">Top plans</h2>
      <p>Investment Plans Handpicked by Experts to Grow your Wealth</p>
      <div className="lil-flex lil-flex-wrap">
        {SECTION_TOP_PLANS.map(ele => {
          return (
            <Link route={`/save/plan/${ele.id}`} key={ele.id}>
              <div className="lil-w-1/3 lil-pr-5 lil-mt-10 lil-cursor-pointer sm:lil-w-full sm:lil-pr-0">
                <div
                  className={`${styles['plans']}  lil-border-sm lil-border-grey-350 lil-rounded-xl`}
                >
                  <div
                    className={`${styles['headerContainer']} lil-rounded-t-xl`}
                    style={{ background: ele.color }}
                  >
                    <div
                      className={`lil-flex lil-justify-between lil-px-4 lil-w-full ${styles['header']}`}
                    >
                      <h6 className="lil-text-s-24 sm:lil-w-2/3">
                        {ele.title}
                      </h6>
                      <div>
                        <p className="lil-text-s-12">5 YR RETURN</p>
                        <p
                          className={`${styles['percentage']} lil-text-font-500  lil-font-bold lil-text-s-20`}
                        >
                          {ele.return}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="lil-mt-3 lil-p-4">
                    <p className="lil-h-24 lil-text-base sm:lil-h-auto">
                      {ele.description}
                    </p>
                    <div className="lil-mt-10">
                      <p className="lil-text-s-12">FUND IN THE BASKET</p>
                      <div className="lil-flex">
                        {ele.funds.map(fund => {
                          return (
                            <img
                              src={`${CDN_CLRSAVE_URL}/clearsave/images/${fund.image}`}
                              height="28"
                              width="28"
                              className="lil-mr-3 lil-h-8"
                            ></img>
                          );
                        })}
                      </div>
                    </div>

                    <div className="lil-flex lil-justify-between lil-mt-10">
                      <div>
                        <p className="lil-text-s-12">LOCK-IN PERIOD</p>
                        <p className="lil-text-base lil-text-font-500 lil-font-bold">
                          {ele.lockInPeriod}
                        </p>
                      </div>
                      <div>
                        <p className="lil-text-s-12">DURATION</p>
                        <p className="lil-text-base lil-text-font-500 lil-font-bold">
                          {ele.duration}
                        </p>
                      </div>
                    </div>
                    <div className="lil-w-full lil-mt-10">
                      <button className="lil-btn lil-btn-blue lil-w-full">
                        Invest now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/topPlansSection/topPlansSection.tsx